import { render, staticRenderFns } from "./newsletter-sticky.vue?vue&type=template&id=78f3c2a7"
import script from "./newsletter-sticky.vue?vue&type=script&lang=js"
export * from "./newsletter-sticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports